export default "__VITE_ASSET__R4Z41PEH__"